import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AppstoreOutlined,
  UsergroupAddOutlined,
  OrderedListOutlined,
  SolutionOutlined,
  LogoutOutlined,
  HomeOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";
import { useAuthContext } from "../../Auth/AuthContext";

const Sidebar = () => {
  const [activeItem, setActiveItem] = useState("Trang Chủ");
  const location = useLocation();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuthContext();

  useEffect(() => {
    const pathname = location.pathname;
    if (pathname === "/admin") {
      setActiveItem("Trang Chủ");
    } else if (pathname.includes("/products")) {
      setActiveItem("Sản Phẩm");
    } else if (pathname.includes("/producttype")) {
      setActiveItem("Loại Sản Phẩm");
    } else if (pathname.includes("/customer")) {
      setActiveItem("Khách Hàng");
    } else if (pathname.includes("/order")) {
      setActiveItem("Đơn Hàng");
    } else if (pathname.includes("/supplier")) {
      setActiveItem("Nhà Cung Cấp");
    }
  }, [location]);

  const handleItemClick = (itemName) => {
    setActiveItem(itemName);
  };

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const menuItems = [
    {
      name: "Trang Chủ",
      path: "/admin",
      icon: <HomeOutlined className="text-lg" />,
    },
    {
      name: "Sản Phẩm",
      path: "/admin/products/list",
      icon: <AppstoreOutlined className="text-lg" />,
    },
    {
      name: "Loại Sản Phẩm",
      path: "/admin/producttype",
      icon: <UsergroupAddOutlined className="text-lg" />,
    },
    {
      name: "Khách Hàng",
      path: "/admin/customer",
      icon: <TeamOutlined className="text-lg" />,
    },
    {
      name: "Đơn Hàng",
      path: "/admin/order",
      icon: <OrderedListOutlined className="text-lg" />,
    },
    {
      name: "Nhà Cung Cấp",
      path: "/admin/supplier",
      icon: <SolutionOutlined className="text-lg" />,
    },
  ];

  return (
    <div className="fixed left-0 top-0 h-screen w-64 bg-white shadow-xl border-r border-gray-200 z-50">
      {/* Header */}
      <div className="p-5 border-b border-gray-100">
        <div className="flex flex-col items-center space-y-2">
          <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-md">
            <AppstoreOutlined className="text-white text-lg" />
          </div>
          <h2 className="text-lg font-semibold text-gray-800">Lưu Gia Admin</h2>
          <p className="text-gray-500 text-xs">Quản lý hệ thống</p>
        </div>
      </div>

      {/* Navigation Menu */}
      <div className="flex-1 px-3 py-4 space-y-1">
        {menuItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={`group flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${
              activeItem === item.name
                ? "bg-blue-50 text-blue-700 border border-blue-200 shadow-sm"
                : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
            }`}
            onClick={() => handleItemClick(item.name)}
          >
            <div
              className={`flex items-center justify-center w-8 h-8 rounded-md transition-all duration-200 ${
                activeItem === item.name
                  ? "bg-blue-100 text-blue-600"
                  : "bg-gray-100 text-gray-500 group-hover:bg-gray-200 group-hover:text-gray-700"
              }`}
            >
              {item.icon}
            </div>
            <span className="ml-3 font-medium text-sm">{item.name}</span>
            {activeItem === item.name && (
              <div className="ml-auto w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
            )}
          </Link>
        ))}
      </div>

      {/* Logout Section */}
      <div className="p-3 border-t border-gray-100">
        <button
          onClick={() => setShowConfirmationModal(true)}
          className="group w-full flex items-center px-3 py-2.5 rounded-lg text-gray-600 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
        >
          <div className="flex items-center justify-center w-8 h-8 rounded-md bg-gray-100 text-gray-500 group-hover:bg-red-100 group-hover:text-red-600 transition-all duration-200">
            <LogoutOutlined className="text-base" />
          </div>
          <span className="ml-3 font-medium text-sm">Đăng xuất</span>
        </button>
      </div>

      {/* Logout Confirmation Modal */}
      <Modal
        open={showConfirmationModal}
        onCancel={() => setShowConfirmationModal(false)}
        onOk={handleLogout}
        title={
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
              <LogoutOutlined className="text-red-500" />
            </div>
            <span className="text-gray-800 font-medium">
              Xác nhận đăng xuất
            </span>
          </div>
        }
        okText="Đăng xuất"
        cancelText="Hủy"
        okButtonProps={{
          className:
            "bg-red-500 hover:bg-red-600 border-red-500 hover:border-red-600",
        }}
        centered
      >
        <div className="py-4">
          <p className="text-gray-600 text-sm">
            Bạn có chắc chắn muốn đăng xuất khỏi hệ thống quản lý không?
          </p>
          <p className="text-xs text-gray-500 mt-2">
            Bạn sẽ cần đăng nhập lại để tiếp tục sử dụng.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default Sidebar;
